var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-5"},_vm._l((_vm.comments),function(comment){return _c('Comment',{key:comment._id,attrs:{"articleId":_vm.articleId,"comment":comment},on:{"delete-comment":_vm.onDeleteComment}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }